module.exports = __webpack_public_path__ + "img/voteDisable.542cc159.png";